import React, { useEffect } from 'react';


import Gstprograme from './Gstprograme';
import Gstprogrameoverview from './Gstprogrameoverview';



const Home = () => {
     // Scroll to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts

  return (
    <div style={{backgroundColor:'white'}}>
        <Gstprograme/>
        <Gstprogrameoverview/>
      
        

        <style>
          {`
          h1,h2,h3,h4,h5,h6,p{
          fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif';
          }
          `}
        </style>
    </div>
  )
}

export default Home